var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9424_38491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8813 16.3688C12.052 16.5397 12.2762 16.6251 12.5 16.6251C12.7237 16.6251 12.9479 16.5397 13.1186 16.3688L18.3687 11.1187C18.6191 10.8685 18.6938 10.4921 18.5584 10.1653C18.423 9.83824 18.1041 9.62513 17.7501 9.62513H16.0001V0.8749C16.0001 0.391695 15.6084 0 15.1252 0H9.87502C9.39181 0 9.00012 0.391695 9.00012 0.8749V9.62513H7.25007C6.89611 9.62513 6.57718 9.83824 6.44177 10.1653C6.30635 10.4921 6.38109 10.8685 6.63145 11.1187L11.8816 16.3688H11.8813ZM9.87502 11.3752C10.3582 11.3752 10.7499 10.9835 10.7499 10.5003V1.75005H14.25V10.5C14.25 10.9832 14.6417 11.3749 15.1249 11.3749H15.6375L12.5 14.5124L9.36246 11.3749H9.87502V11.3752Z",
    fill: "#5F5D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8749 17.5H17.7498C17.5177 17.5 17.2953 17.5922 17.1312 17.7562L15.6375 19.25H9.36245L7.86868 17.7562C7.70466 17.5922 7.48192 17.5 7.25006 17.5H1.12478C0.641573 17.5 0.249878 17.8917 0.249878 18.3749V25.3748C0.249878 26.8222 1.42743 27.9998 2.87482 27.9998H22.1248C23.5722 27.9998 24.7498 26.8222 24.7498 25.3748V18.3749C24.7498 17.8917 24.3581 17.5 23.8749 17.5ZM6.88723 19.25L8.38099 20.7438C8.54502 20.9078 8.76776 21.0001 8.99962 21.0001H15.9996C16.2317 21.0001 16.4541 20.9078 16.6182 20.7438L18.1119 19.25H22.9995V22.7501H1.99992V19.25H6.88747H6.88723ZM22.1248 26.25H2.87482C2.39236 26.25 1.99992 25.8575 1.99992 25.3751V24.5002H23V25.3751C23 25.8575 22.6076 26.25 22.1251 26.25H22.1248Z",
    fill: "#5F5D5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9424_38491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5002,
    height: 28,
    fill: "white",
    transform: "translate(0.249878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon3);
export default __webpack_public_path__ + "static/media/download-icon-3.c793ce2591285472f7f0fb1cd87fb134.svg";
export { ForwardRef as ReactComponent };